module.exports = __webpack_public_path__ + "static/media/ic_mobile.aff49e64.svg";